<template>
    <section :class="{vertical, loading}">
        <div class="highlight" v-if="loading">
            <div class="highlight_content highlight_placeholder">
                <router-link class="highlight_image" to="#">
                    <img src="#" alt="">
                </router-link>
                <h2 class="highlight_title">
                    <router-link v-text="'#'" to="#"/>
                </h2>
                <BetButton
                to="#"
                text="Ver mais"
                :mode="buttonMode"
                class="highlight_button"/>
            </div>
        </div>
        <div class="highlight"
            v-else
            v-for="post in highlightPosts"
            :key="post.id">
            <div class="highlight_content" @click.prevent="goToPost($event, post)">
                <router-link class="highlight_image" :to="post.link">
                    <img :src="post.images.medium" alt="">
                </router-link>
                <h2 class="highlight_title">
                    <router-link v-text="post.title.rendered" :to="post.link"/>
                </h2>
                <BetButton
                :to="post.link"
                text="Ver mais"
                :mode="buttonMode"
                class="highlight_button"/>
            </div>
        </div>
    </section>
</template>

<script>
    import BetButton from '@/components/BetButton.vue';

    export default {
        name: 'HighlightsComponent',
        components: {
            BetButton,
        },
        props: {
            category: {
                type: String,
                default: 'highlight',
            },
            vertical: {
                type: Boolean,
                default: false
            },
            buttonMode: {
                type: String,
                default: 'blackFilled'
            },
            posts: {
                default: null
            },
        },
        data() {
            return {
            }
        },
        methods: {
            goToPost(e, post) {
                if(e.target.classList.contains('highlight_content')) {
                    this.$router.push(post.link)
                }
            },
        },
        watch: {
            postsCategory: {
                immediate: true,
                handler() {
                    if( this.postsCategory == null ) return
                    this.$store.dispatch('posts/getCategory', this.postsCategory)
                },
            },
            loading: {
                immediate: true,
                handler() {
                    this.$emit('loaded')
                },
            },
        },
        computed: {
            categoryState() {
                if( this.postsCategory == null ) return null
                return this.$store.getters['posts/categoryState'](this.postsCategory.id)
            },
            loading() {
                if( this.categoryState == null ) return true
                return !this.categoryState.complete
            },
            postsCategory() {
                return this.$store.getters['categories/slug'](this.category)
            },
            highlightPosts() {
                if( this.posts != null ) {
                    return this.posts
                }
                if( this.postsCategory == null ) {
                    return []
                }
                return this.$store.getters['posts/category'](this.postsCategory, 2)
            },
        },
        mounted() {
            this.$store.dispatch('categories/getOne', this.category)
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/colors';
@import '@/assets/scss/queries';
@import '@/assets/scss/fonts';

@keyframes slideInFromLeft {
    0% {
        opacity: 0;
        transform: translateX(50%);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes grow {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.05);
    }
}

@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}


section {
    --highlight-card-max-width: 100%;
    --highlight-max-width: 100%;
    --highlight-margin: auto;
    --image-offset: 1.2rem;
    --content-padding: 1.3rem;
    --btn-font-size: 0.5rem;

    @include media(sm) {
        --highlight-card-max-width: calc(var(--content-width) * .3);
        --highlight-max-width: calc(100vw - var(--side-padding));
        --highlight-margin: 0 auto 0 0;
        --image-offset: 3rem;
        --btn-font-size: 0.62669rem;

        header + & {
            //--highlight-margin: calc(var(--content-width) * -.15) auto 0 0;
        }

        &.vertical {
            --highlight-card-max-width: 100%;
            --highlight-max-width: 100%;
        }
    }

    position: relative;
    z-index: 2;
    height: fit-content;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left center;
    display: flex;
    justify-content: flex-end;
    gap: 3%;

    width: var(--content-width);
    margin: var(--highlight-margin);
    max-width: var(--highlight-card-max-width);

    animation-name: fade;
    animation-duration: 1s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    a {
        color: $color-white;
        text-decoration: none;
    }

    @include media(sm) {
        max-width: calc(100vw - var(--side-padding));
        padding: 0 0 4rem 1.3rem;
        width: 100%;
        background-image: url('@/assets/images/highlights-bg.png');
    }

    &.vertical {
        background-image: none;
        padding: 0;
        gap: 4rem;
        flex-direction: column;

        .highlight {
            width: 100%;
            margin-top: calc(var(--image-offset) - var(--content-padding));

            &_content {
                background-color: transparent;
                border: 2px solid $color-betano;
                box-shadow: 0px 0px 8px rgba($color-betano, .5);
            }

            &_image {
                box-shadow: none;
            }

            &_button {
                border-color: $color-white;
                color: $color-white;
                box-shadow: none;
                background: transparent;
            }
        }
    }
}

.highlight {
    height: min-content;
    flex-grow: 1;
    flex-basis: 0;

    animation: slideInFromLeft 1s;
    animation-delay: .5s;
    animation-timing-function: cubic-bezier(0.83, 0, 0.17, 1);
    animation-fill-mode: both;

    max-width: var(--highlight-card-max-width);

    @include media(sm, true) {
        padding: var(--image-offset) 0 0;
    }

    @include media(lg) {
    }

    &+& {
        animation-delay: .75s;
    }

    &:hover {
        // animation-fill-mode: both;
    transform: translate(0, -5px);
    // box-shadow: 0px 0px 8px 0px $color-betano;
    }

    &_content, &_image {
        transition: .2s ease-out;
        transition-property: transform, filter, box-shadow;
    }

    &_placeholder {
        opacity: 0;
    }

    &_content {
        width: 100%;
        height: 100%;
        background-color: $color-betano;
        cursor: pointer;
        position: relative;
        z-index: 1;
        display: grid;
        gap: 1.2rem;
        padding: 2vw;
        grid-template-rows: min-content 1fr min-content;
        grid-template-areas: 
            "image image"
        "title title"
        "button share";

    @include media(sm) {
        padding: var(--content-padding);
        perspective: 100px;
    }

    &:hover {
        transform: scale(1.05) translate(0, 5px);
        filter: drop-shadow(0px 0px 32px $color-betano);

        & > .highlight_image {
            transform: scale(1.05) rotate3d(1, 0, 0, 1deg);

            img {
                transition-timing-function: linear;
                transition-duration: .2s;
                // transform: scale(1.25);
            }
        }
    }
    }

    &_image {
        grid-area: image;
        position: relative;
        width: 100%;
        min-height: 0;
        height: 0;
        padding: #{9 / 16 * 100%} 0 0;
        z-index: 1;
        margin-top: calc(-1 * var(--image-offset));
        box-shadow: 0px 4px 10px 0px rgba(117, 19, 19, 0.70);
        overflow: hidden;
        transform-origin: bottom center;

        img {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            object-fit: cover;
            transition-duration: .5s;
            transition-property: transform;
        }
    }

    &_title {
        --max-lines: 2;
        --font-size: .75rem;
        --lh: calc(1.0 * var(--font-size));

        @include media(sm) {
            --font-size: 0.9375rem;
            --lh: calc(1.2 * var(--font-size));
        }

        line-height: var(--lh);
        height: calc(var(--lh) * var(--max-lines));
        grid-area: title;

        font-size: var(--font-size);
        font-family: $ff-headings;
        text-transform: uppercase;
        line-height: var(--lh);
        color: #fff;
    }

    &_button {
        grid-area: button;
        font-size: var(--btn-font-size);
        padding: 0.4375rem 0.625rem;
        // border-color: black;
    }
}

</style>
